export const YOTPO_SITE_RATINGS_LOAD = 'yotpo/YOTPO_SITE_RATINGS_LOAD';
export const YOTPO_SITE_RATINGS_SUCCESS = 'yotpo/YOTPO_SITE_RATINGS_SUCCESS';
export const YOTPO_SITE_RATINGS_FAILURE = 'yotpo/YOTPO_SITE_RATINGS_FAILURE';
export const YOTPO_SITE_RATINGS_TIMEOUT = 'yotpo/YOTPO_SITE_RATINGS_TIMEOUT';
